//引入外部模組
import {transitionEnd} from '@/common';




//頁面淡入淡出
class LinkEffect {
  constructor() {
    this.le   = $('.linkEffect');
    this.body = $('html, body');
  }
  effect() {
    this.le.each((i, e) => {
      if($(e).prop('href').length > 0){
        $(e).on('click', (j) => {
          j.preventDefault();
          const $this = $(j.currentTarget);
          const url   = $this.attr('href');
          this.body.addClass('active').one(transitionEnd, () => {
            window.location = url;
          });
        });
      }
    });
  }
}




//輸出
export {LinkEffect};


// WEBPACK FOOTER //
// ./js_new/link_effect.js